<template>
  <div>
    <!-- 添加优惠包对话框 -->
    <el-dialog
      title="添加优惠包"
      :visible.sync="addDialogVisible"
      width="80%"
      append-to-body
      @close="addDialogClosed">
      <el-form
        ref="addFormRef"
        :model="addForm"
        :rules="rules"
        label-width="100px">
        <el-row>
          <!--名称-->
          <el-col :span="12">
            <el-form-item label="名称" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入名称" />
            </el-form-item>
          </el-col>

          <!--价格说明-->
          <el-col :span="12">
            <el-form-item label="价格说明" prop="costBrief">
              <el-input v-model="addForm.costBrief" placeholder="请输入价格说明" />
            </el-form-item>
          </el-col>

          <!--价格说明2-->
          <el-col :span="12">
            <el-form-item label="价格说明2" prop="costBrief">
              <el-input v-model="addForm.costBrief2" placeholder="请输入价格说明" />
            </el-form-item>
          </el-col>

          <!--原价-->
          <el-col :span="12">
            <el-form-item label="原价" prop="cost">
              <el-input v-model="addForm.cost" placeholder="请输入原价" />
            </el-form-item>
          </el-col>

          <!--现价-->
          <el-col :span="12">
            <el-form-item label="现价" prop="price">
              <el-input v-model="addForm.price" placeholder="请输入现价" />
            </el-form-item>
          </el-col>

          <!--开始时间-->
          <el-col :span="12">
            <el-form-item label="开始时间" prop="startTime">
              <el-date-picker
                v-model="addForm.startTime"
                style="width: 100%"
                type="datetime"
                value-format="timestamp"
                placeholder="请选择开始时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <!--结束时间-->
          <el-col :span="12">
            <el-form-item label="结束时间" prop="endTime">
              <el-date-picker
                v-model="addForm.endTime"
                type="datetime"
                style="width: 100%"
                value-format="timestamp"
                placeholder="请选择结束时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <!--状态-->
          <el-col :span="12">
            <el-form-item label="状态" prop="enumState">
              <el-select v-model="addForm.enumState" placeholder="请选择" style="width: 100%">
                <el-option
                  v-for="item in enumEnable"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!--优惠包类型-->
          <el-col :span="12">
            <el-form-item label="优惠包类型" prop="enumType">
              <el-select v-model="addForm.enumType" placeholder="请选择优惠包类型" @change="getPreferentialType" style="width: 100%">
                <el-option
                  v-for="item in enumTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!--优惠劵类型-->
          <el-col :span="12">
            <el-form-item label="优惠劵类型" prop="refId">
              <el-select v-model="addForm.refId" placeholder="请选择优惠包类型" style="width: 100%">
                <el-option
                  v-for="item in refIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--排序-->
          <el-col :span="12">
            <el-form-item label="排序" prop="resort">
              <el-input v-model="addForm.resort" placeholder="请输入排序" />
            </el-form-item>
          </el-col>

          <!--说明-->
          <el-col :span="24">
            <el-form-item label="说明" prop="introduce">
<!--              <Editor v-model="addForm.brief" ></Editor>-->
              <el-input type="textarea" v-model="addForm.brief" placeholder="请输入说明" />
            </el-form-item>
          </el-col>

          <!--予約规定-->
          <el-col :span="24">
            <el-form-item label="予約规定" prop="introduce">
              <el-input type="textarea" v-model="addForm.atRules" placeholder="请输入说明" />
            </el-form-item>
          </el-col>

          <!--缩略图-->
          <el-col :span="24" class="label">
            <el-form-item label="缩略图">
              <thumbnail v-model="addForm.thumbnail" :md5s="addForm.thumbnail"></thumbnail>
            </el-form-item>
          </el-col>

          <!--轮播图-->
          <el-col :span="24" class="label">
            <el-form-item label="轮播图">
              <thumbnail-list v-model="addForm.carousel" :md5List="addForm.carousel"></thumbnail-list>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button @click="addSale">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addSale } from '@/api/sale/sale'
import { getData } from '@/utils/code'
import Thumbnail from '@/components/common/thumbnail/thumbnails'
import ThumbnailList from '@/components/common/thumbnailList/thumbnailList'
import { enumEnable, enumSale } from '@/js/enum'
import { getCourtName } from '@/api/court/court'
import { getTravelsName } from '@/api/travel/travel'
import { getGoodsName } from '@/api/goods/goods'
import Editor from '@/components/common/editor/editor'
import { saleRules } from '@/js/rules'

export default {
  name: 'addSale',
  components: { Thumbnail, ThumbnailList ,Editor },
  data() {
    let time = Date.parse(new Date());
    return {
      enumEnable: enumEnable,
      addForm: {
        enumState: 'NORMAL',
        startTime: time

      },
      addDialogVisible: false,
      // 规则
      rules: saleRules,
      enumTypeList: enumSale,
      refIdList: [],
    }
  },
  methods: {
    cancel() {
      this.addDialogVisible = false
      this.addForm = {}
    },
    addDialog() {
      this.addDialogVisible = true
    },
    // 监听添加对话框的关闭事件，重置表单
    addDialogClosed() {
      this.addForm = {}
    },
    // 添加
    addSale() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        addSale(this.addForm).then((response) => {
          let data = getData(response)
          if (data !== null) {
            this.$emit('refresh-list')
            this.addDialogVisible = false
          }
        })
      })
    },

    //获取优惠劵类型
    getPreferentialType() {
      const val = this.addForm.enumType
      //球场
      if (val === 'COURT') {
        getCourtName().then((res) => {
          this.refIdList = res.code === '0' ? res.data : []
        })
      }

      //旅行
      if (val === 'TRAVEL') {
        getTravelsName().then((res) => {
          this.refIdList = res.code === '0' ? res.data : []
        })
      }

      //商品
      if (val === 'GOODS') {
        getGoodsName().then((res) => {
          this.refIdList = res.code === '0' ? res.data : []
        })
      }
    }

  }
}
</script>

<style scoped>

</style>
